import React, { Component } from "react";
import { connect } from "react-redux";
import {
  WithStyles,
  withStyles,
  Button,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  Radio,
  createStyles,
  Theme,
  Menu,
  MenuItem,
  Link,
  ClickAwayListener,
  RadioGroup,
} from "@material-ui/core";
import { Error } from "@material-ui/icons";

import { MyPATDialog, MyPATIconButton, MyPATSelect } from "../../common";

import { bindActionCreators } from "redux";
import * as XLSX from "xlsx";

import courseManagementService from "../service/courseManagementServices";
import * as courseManagementActions from "../actions/courseManagementActions";
import cx from "classnames";
import moment from "moment";

import _ from "lodash";
import { CloseOutlined as CloseIcon } from "@material-ui/icons";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
  getActiveGoals
} from "../actions/courseManagementActions";
import { Goal } from "../types/interfaces/Goal";
import { ExistingScheduledTest } from "../types/interfaces/ExistingScheduledTest";
import { createErrorSheet } from "../helpers/helpers";
const styles = (theme: Theme) =>
  createStyles({
    menuItem: {
      borderStyle: "solid",
      borderBottomWidth: 1,
      borderColor: theme.palette.grey[300],
      padding: 0,
      height: "auto",
      minWidth: "170px",
      "&:last-child": {
        borderBottomWidth: 0,
      },
      "& a": {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingRight: theme.spacing.unit * 2,
        paddingLeft: theme.spacing.unit * 2,
        width: "100%",
      },
      "& img, & p": {
        display: "inline-block",
        verticalAlign: "middle",
        fontSize: 14,
        lineHeight: "19px",
        color: "#333333",
      },
    },
    bulkTitle: {
      fontSize: 20,
      fontWeight: 600,
      margin: 0,
    },
    orDevider: {
      position: "relative",
      marginBottom: 50,
      alignItems: "center",
      marginTop: 10,
      "&::before": {
        top: "50%",
        left: "47%",
        content: '"OR"',
        position: "absolute",
        width: "30px",
        height: "30px",
        backgroundColor: "#e5edf5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
        transform: "translate(0%, -50%)",
        borderRadius: "50%",
        fontWeight: 600,
        fontSize: 12,
        color: "#666",
      },
      "&::after": {
        left: "50%",
        content: '" "',
        position: "absolute",
        border: "1px solid #e4e4e4",
        height: "100%",
      },
      "& button": {
        margin: "10px 0",
      },
    },
    paddingLeft: {
      paddingLeft: 40,
    },

    paddingRight: {
      paddingRight: 40,
    },
    disabled: {
      opacity: 0.5,
      cursor: "default",
      pointerEvents: "none",
    },
    optionContainer: {
      marginTop: 10,
      position: "relative",
      "& input": {
        border: "1px solid #DFDFDF",
        width: "100%",
        padding: "10px",
        borderRadius: 4,
        background: 'none',
        height: 45,
        lineHeight: '45px',
        cursor: 'pointer',
        paddingRight: 70,
        textOverflow: 'ellipsis',
        fontSize: 14,
        '&:focus-visible':{
          outline: '2px solid #1d7dea',
        }
      },
    },
    optionlistContainer: {
      position: "relative",
      "&:hover": {
        cursor: "pointer",
      },
      "&::after": {
        top: "5px",
        right: "18px",
        border: "solid rgb(0 0 0 / 0%)",
        height: 0,
        content: '" "',
        zIndex: 999,
        position: "absolute",
        transform: "rotate(226deg)",
        boxShadow: "1px 1px 1px #DFDFDF",
        background: "rgb(255 255 255)",
        borderColor: "rgb(194 225 245 / 0%)",
        borderWidth: 9,
        borderBottomColor: "rgb(255 255 255)",
      },
    },
    optionList: {
      width: "100%",
      border: "1px solid #DFDFDF",
      display: "block",
      position: "absolute",
      backgroundColor: "#fff",
      top: "13px",
      borderRadius: "7px",
      maxHeight: 250,
      overflowX: "hidden",
      overflowY: "auto",
      zIndex: 2,
      "& input": {
        marginTop: 15,
        paddingLeft: 40,
      },
      "& span": {
        display: "block",
        padding: "1px 0px 2px 10px",
        cursor: "pointer",
      },

      // top: "-16px",
      // right: "15px",
      // width: 0,
      // height: 0,
      // content: '" "',
      // position: "absolute",
      // marginLeft: "-20px",
      // borderLeft: "10px solid transparent",
      // borderRight: "10px solid transparent",
      // borderBottom: "15px solid #dadada",
      // borderTopLeftRadius: "20px",
      // borderTopRightRadius: "0px",
      // }
    },
    optionListEdit: {
      "& span": {
        padding: "10px 15px",
        borderBottom: "1px solid #eee",
      },
    },
    searchContainer: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: '#fff',
      paddingBottom: 15,
      borderBottom: '1px solid #e6e6e6',
      marginBottom: 10,
      paddingLeft: 15,
      paddingRight: 15,
      "& img": {
        left: 29,
        position: "absolute",
        top: 29,
      },
    },
    parentSearchContainer: {
      position: 'relative',
      backgroundColor: '#fff',
      marginTop: 10,
      '& input':{
        width: '100%',
        background: 'none',
        padding: '20px 20px 20px 15px',
        height: 40,
        lineHeight: 40,
        border: '1px solid #DFDFDF',
        borderRadius: 4,
        '&:focus-visible':{
          outline: '2px solid #1d7dea',
        }
      },
      "& img": {
        right: 15,
        position: "absolute",
        top: 12,
      },
    },
    padding2x: {
      padding: "10px 0",
    },
    courseTitle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#666',
    },
    plusCourse: {
      position: "relative",
      "& span": {
        position: "absolute",
        right: 0,
        top: 8,
        color: "#1d7dea",
        width: 30,
        height: 30,
        backgroundColor: "#e8f2fd",
        borderRadius: "50%",
        fontSize: 13,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
        marginRight: 40,
      },
    },
    fileInfo: {
      fontSize: 12,
      lineHeight: "16px",
      color: "#999",
      display: "block",
      fontWeight: "normal",
    },
    uploadPreview: {
      "&>:first-child": {
        justifyContent: "center",
        "&>:first-child": {
          "&>:first-child": {
            margin: "16px 0",
          },
        },
      },
    },
    textCenter: {
      textAlign: "center",
    },
    noBorder: {
      borderBottom: 0,
    },
    iconRoot: {
      fill: theme.palette.text.secondary,
      // opacity: 0.5,
      margin: 0,
      width: "2rem",
      height: "2rem",
    },
    buttonCloseCont: {
      position: "relative",
      height: 20,
      "& button": {
        position: "absolute",
        right: "-15px",
        top: "-35px",
        border: "none",
      },
    },
    arrowIcon: {
      position: "absolute",
      right: 10,
      top: 12,
      transform: "scale(1.3)",
      zIndex: 1,
      width: 20,
      height: 20,
      backgroundColor: "#fff",
      cursor: 'pointer',
      "& img": {
        // opacity: 0.3,
        width: 15,
      },
    },
    testRadioGroup: {
      width: "100%",
      display: "inline-block",
      textAlign: "center",
      "& $label": {
        "&>:nth-child(2)": {
          fontSize: 16,
          fontWeight: 400,
          color: "#333",
        },
      },
    },
    customSelect:{
      marginBottom: 10,
      '&>div:nth-of-type(1)':{
        width: '100%',
        marginTop: 10,
        '& select':{
          height: 44,
          fontSize: '14px',
        }
      }
    },
    errorText: {
      color: '#F21D1D',
      verticalAlign: "middle",
      marginTop: "3px",
      "& svg": {
        verticalAlign: "bottom",
      },
    },
    mapDialog:{
      marginTop: '-15px',
    },
    greyBackground: {
      backgroundColor: '#ccc'
    }
  });
enum mappingType {
  mapped = "mapped",
  unmapped = "unmapped",
}
interface MapSCheduledTestProps extends WithStyles<typeof styles> {
  classes: any;
  courseList: any[];
  getCourseList: Function;
  setBulkImportTest: Function;
  fetchExistingScheduledTests: Function;
  openMapScheduled: boolean;
  closeBulkImport: Function;
  redirectToBulkImport: Function;
  getActiveGoals: Function;
  goals: Goal[];
  fetchScheduleTests: Function;
  scheduledTests: ExistingScheduledTest[];
}

interface MapSCheduledTestState {
  openConfirmationPopup: boolean;
  mappingType: mappingType;
  filteredGoals: Goal[];
  showSingleGoalDropdown: boolean;
  selectedGoal: Goal | { [name: string]: string };
  isLoading: boolean;
  showTestDropdown: boolean;
  selectedTest: string[];
  filteredTestList: ExistingScheduledTest[];
  primaryTest:ExistingScheduledTest|undefined;
  disabledPrimaryDropDown:boolean;
  testCourseCount: number;
  scheduleIds: string[];
  inputTestId: string;
  formErrors:any;
  openDialog: boolean;
  hoverGoalId: string;
}

class MapSCheduledTest extends Component<
  MapSCheduledTestProps,
  MapSCheduledTestState
> {
  constructor(props: MapSCheduledTestProps) {
    super(props);
    this.state = {
      openConfirmationPopup: false,
      openDialog: false,
      mappingType: mappingType.unmapped,
      filteredGoals: [],
      showSingleGoalDropdown: false,
      selectedGoal: { name: "" },
      isLoading: false,
      showTestDropdown: false,
      filteredTestList: [],
      selectedTest: [],
      primaryTest:undefined,
      disabledPrimaryDropDown:false,
      testCourseCount: 0,
      scheduleIds: [],
      inputTestId: '',
      formErrors:{},
      hoverGoalId: ''
    };
    this.getFilteredGoals = _.debounce(this.getFilteredGoals, 200);
    this.getTestSuggestions = _.debounce(this.getTestSuggestions, 200);
    this.toggleGoalDropDown = _.debounce(this.toggleGoalDropDown, 100);
    this.toggleTestDropdown = _.debounce(this.toggleTestDropdown, 100);
    this.handleTestID=_.debounce(this.handleTestID, 200);
  }
  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (nextProps.openMapScheduled != prevState.openDialog) {
      return {
        openDialog: nextProps.openMapScheduled,
      };
    } else return null;
  }
  componentDidMount() {}
  componentDidUpdate(
    prevProps: MapSCheduledTestProps,
    prevState: MapSCheduledTestState
  ) {
    if (this.state.selectedGoal !== prevState.selectedGoal && !_.isEmpty(this.state.selectedGoal._id)) {
      this.getScheduledTests();
    }
  }
  downloadCourseSheet = async () => {
    const { scheduleIds } = this.state;

    let payload = {
      scheduleTestIds: scheduleIds,
      isCount: false
    }
    let packageSkus =await courseManagementService.fetchCourseDataListWithScheduleId(payload);
    packageSkus = packageSkus.packageSkus;
    const data:any[]=[];
    packageSkus.forEach((packageData:any)=>{
      const obj:any={};
      for(let key in packageData){
        if(key === "sku" || key === "reasons" || key === "status" || key === "mainTestCount" || key === "milestoneTestCount" ) {
          obj["sku".toUpperCase()] = packageData["sku"];
        }
      }
      data.push(obj);
    })
    if(data.length==packageSkus.length){
        createErrorSheet(data,'CourseSKUs.xlsx');
    }
  } 
  openConfirmationDialog = async () => {
    const { scheduledTests } = this.props;
    const { selectedTest } = this.state;
    let scheduleIds: any[] = scheduledTests.filter( (testData) => selectedTest.includes(testData._id));
    scheduleIds = scheduleIds.map((test) => test.scheduleID);
    let payload = {
      scheduleTestIds: scheduleIds,
      isCount: true
    }
    let testCourseCount =await courseManagementService.fetchCourseDataListWithScheduleId(payload);
    testCourseCount = testCourseCount.count;
    this.setState({ openConfirmationPopup: true,testCourseCount, scheduleIds });
  }

  closeConfirmationDialog() {
    this.setState({ openConfirmationPopup: false });
  }
  resetPopup() {
    const {formErrors} = this.state
    const newFormErrors={...formErrors};
      newFormErrors['testId']='';
   
    this.setState({ scheduleIds: [], testCourseCount: 0, selectedTest: [], inputTestId: '', primaryTest:undefined,selectedGoal: { name: "" }, disabledPrimaryDropDown: false,
    formErrors: newFormErrors });

  }

  handleRadio = () => {
    const { classes } = this.props;
    const { mappingType } = this.state;
    return (
      <div className={[classes.root, classes.mapDialog].join(' ')}>
        <Grid container justify="space-between">
          <RadioGroup
            name="actionType"
            classes={{
              root: classes.testRadioGroup,
            }}
            className={classes.courseRadioGroup}
            onChange={(_: any, value: string) => {
              this.setState({ mappingType: value } as any)
              this.resetPopup()
            }
            }
            value={mappingType}
          >
            <FormControlLabel
              control={
                <Radio
                  color="primary"
                  classes={{ root: classes.testRadioRoot }}
                />
              }
              label={"Map Unmappped Test"}
              value={"unmapped"}
            />
            <FormControlLabel
              control={
                <Radio
                  color="primary"
                  classes={{ root: classes.testRadioRoot }}
                />
              }
              value={"mapped"}
              label={"Re-Map Existing Test"}
            />
          </RadioGroup>
        </Grid>
      </div>
    );
  };
  toggleGoalDropDown = () => {
    const { showSingleGoalDropdown } = this.state;
    const { goals } = this.props;

    this.setState({
      showSingleGoalDropdown: !showSingleGoalDropdown,
      filteredGoals: [...goals],
    });
  };
  toggleTestDropdown = () => {
    const { showTestDropdown } = this.state;
    const { scheduledTests } = this.props;

    this.setState({
      showTestDropdown: !showTestDropdown,
      filteredTestList: [...scheduledTests],
    });
  };
  getFilteredGoals(value: string) {
    const { goals } = this.props;
    const { isLoading } = this.state;
    this.setState({ isLoading: true });
    this.setState((prevState) => {
      let suggestions: any = [];
      value = value.toString();
      value = value.replace(/[{()}]/g, '');
      value = value.replace(/\\|\//g,'')

      if (value.length > 0) {
        value = value.toLowerCase();
        for (let indx = 0; indx < goals.length; indx++) {
          let ug = goals[indx];
          if (ug.name && ug.name.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1) {
            suggestions.push(ug);
          }
        }
      } else {
        suggestions = [...goals];
      }
      return { filteredGoals: suggestions, isLoading: false };
    });
  }
  getTestSuggestions(value: string) {
    const { scheduledTests } = this.props;
    value = value.toString();
    value = value.replace(/[{()}]/g, '');
    value = value.replace(/\\|\//g,'')

    this.setState((prevState) => {
      let suggestions: any = [];
      if (value.length > 0) {
        value = value.toLowerCase();

        for (let indx = 0; indx < scheduledTests.length; indx++) {
          let ug = scheduledTests[indx];
          if (
            ug.displayName &&
            ug.displayName.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1
          ) {
            suggestions.push(ug);
          }
        }
      } else {
        suggestions = [...scheduledTests];
      }
      return { filteredTestList: suggestions };
    });
  }
  getScheduledTests() {
    const { selectedGoal } = this.state;
    this.setState({selectedTest:[],filteredTestList:[],primaryTest:undefined});
    const params = {
      itemType: "scheduledTests",
      id: selectedGoal._id,
    };
    const queryParams = {
      mappingType: this.state.mappingType,
    };
    this.props.fetchScheduleTests({ params, queryParams });
  }
  bulkMapProcess = async () => {
    const { mappingType, selectedGoal, scheduleIds, primaryTest, inputTestId  } = this.state;
    let payload = {
      "mappingType": mappingType === "mapped" ? "remapExisting" : "mapUnmapped",
      "courseId": selectedGoal._id,
      "mappingTestId": inputTestId,
      "testScheduleIds": scheduleIds,
      "primaryTestScheduleId": primaryTest ? primaryTest.scheduleID : ''
    }
    let statusCode =  await courseManagementService.mapScheduledTests(payload);
    if(statusCode !== 422) {
      this.setState({openConfirmationPopup: false, openDialog: false })
      this.props.closeBulkImport();
      this.props.redirectToBulkImport();
    } else {
      this.setState({openConfirmationPopup: false})

    }


  }

  testRenderer = () => {
    const { selectedTest, filteredTestList } = this.state;
    const{scheduledTests}=this.props;
    if (scheduledTests && scheduledTests.length > 0) {
      return (
        scheduledTests &&
        scheduledTests
          .reduce((acc: string[], curr) => {
            if (selectedTest.includes(curr._id)) {
              acc.push(curr.displayName);
            }
            return acc;
          }, [])
          .splice(0, 3)
          .join(", ")
      );
    }
    return [];
  };

  renderPrimaryTestOptions=()=>{
    const { selectedTest, filteredTestList,disabledPrimaryDropDown, primaryTest } = this.state;
    const options=[];
    if(!disabledPrimaryDropDown) {
    options.push(<option value={''}>{'Select Test'}</option>);
    filteredTestList.forEach((t, index) => {
      const { _id, displayName, scheduleID } = t;
      if(selectedTest.includes(_id)){
        options.push(
          <option key={index} value={_id}>
            {displayName}
          </option>
        );
       }
    });
  }else {
    options.push(<option value={primaryTest && primaryTest._id}>{primaryTest && primaryTest.displayName}</option>);

  }
    return options;
  }
  handleTestChange = (event: any) => {
    let eventId = event.target.value;
    let isChecked = event.target.checked;
    let { selectedTest, filteredTestList } = this.state;
    let newSelectedSubjects = [...selectedTest];

    if (isChecked) {
      if (eventId === "SelectAll") {
        newSelectedSubjects = [];
        filteredTestList.forEach((sub) => {
          newSelectedSubjects.push(sub._id);
        });
      } else {
        newSelectedSubjects.push(eventId);
      }
    } else {
      if (eventId === "SelectAll") {
        newSelectedSubjects = [];
      } else {
        let indx = newSelectedSubjects.indexOf(eventId);
        newSelectedSubjects.splice(indx, 1);
      }
    }

    this.setState({ selectedTest: newSelectedSubjects });
  };

  handleTestID=async (contentID:string)=>{
    const{selectedGoal,formErrors}=this.state;
    const res=await courseManagementService.validateMapTestId({testContentId:contentID, courseId:selectedGoal._id})
    const{test,error}=res;
    const newFormErrors={...formErrors};
    if(error){
      newFormErrors['testId']=error;
    }else{
      delete newFormErrors['testId'];
    }
    this.setState({inputTestId: contentID, primaryTest:test,formErrors:newFormErrors,disabledPrimaryDropDown:!_.isEmpty(test)}); 
  }

  handleChange=(event:any)=>{
   const{name,value}=event.target;
   const {filteredTestList}=this.state;
   if(name==='testId'){
     const trimmedValue=value.trim();
     this.setState({inputTestId:trimmedValue});
     if(trimmedValue.length>3){ 
       this.handleTestID(trimmedValue);
     }
    }
    else if(name==="primaryTest"){
      const primaryTest= filteredTestList.find((t)=>t._id===value);
      this.setState({primaryTest})
    } 
  }

  toggleDialog() {
    this.setState({ openDialog: false });
    this.props.closeBulkImport();
  }

  handleMouseHover = (goalId: string) => {
    this.setState( {
      hoverGoalId: goalId

    })
  }
  render() {
    const { classes, goals } = this.props;
    const {
      openConfirmationPopup,
      showSingleGoalDropdown,
      filteredGoals,
      selectedGoal,
      isLoading,
      showTestDropdown,
      selectedTest,
      filteredTestList,
      primaryTest,
      disabledPrimaryDropDown,
      inputTestId,
      formErrors,
      openDialog,
      mappingType,
      hoverGoalId
    } = this.state;

    return (
      <>
        <MyPATDialog
          dialogOpen={openDialog}
          dialogHasActions={true}
          dialogHeading={
            <>
              <h3 className={classes.bulkTitle}> Map Scheduled tests</h3>
            </>
          }
          isApplyCustom
          isfixedDialogActions
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={() => this.toggleDialog()}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: false,
          }}
          customDialogActions={
            <>
              <Grid container justify="center">
                <Grid item>
                  <Button
                    disabled={_.isEmpty(primaryTest) || !inputTestId || formErrors.testId}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.openConfirmationDialog();
                    }}
                  >
                    Map
                  </Button>
                </Grid>
              </Grid>
            </>
          }
        >
          <Grid container>
            <Grid style={{ marginBottom: "10px" }}>
              {this.handleRadio()}
            </Grid>
            <Grid item xs={12} className={classes.padding2x}>
              <Typography variant="h4" className={classes.courseTitle}>
                Select A Goal
              </Typography>
              <div className={classes.optionContainer}>
                <div onClick={this.toggleGoalDropDown}>
                  <input
                    type="text"
                    placeholder="Select A Goal"
                    value={selectedGoal.name}
                  />
                  <Grid className={classes.arrowIcon}>
                    {/* <KeyboardArrowDownIcon /> */}
                    <img src="/assets/svg/dropdown-arrow.svg" />
                  </Grid>
                </div>
                {showSingleGoalDropdown && (
                  <ClickAwayListener onClickAway={this.toggleGoalDropDown}>
                    <div className={classes.optionlistContainer}>
                      <div
                        className={[
                          classes.optionList,
                          classes.optionListEdit,
                        ].join(" ")}
                      >
                        <div className={classes.searchContainer}>
                          <input
                            type="text"
                            placeholder="Search Goal Name"
                            onChange={(event) => {
                              this.getFilteredGoals(event.target.value);
                            }}
                          />
                          <img src="/assets/svg/userManagement/search-icon.svg" />
                        </div>
                        {filteredGoals.length === 0 && !isLoading && (
                        <span>No Goal found</span>
                        )}
                        {isLoading ? (
                          <span>Loading...</span>
                        ) : (
                          (filteredGoals || []).map((goal) => (
                            <span
                              className={(selectedGoal._id === goal._id) || (hoverGoalId === goal._id) ? classes.greyBackground : ""}
                              key={goal._id}
                              onClick={() =>
                                this.setState({ selectedGoal: goal, showSingleGoalDropdown: false, hoverGoalId: '' })
                              }
                              onMouseOver={() => this.handleMouseHover(goal._id)}
                              >
                              {goal.name}
                            </span>
                          ))
                        )}
                      </div>
                    </div>
                  </ClickAwayListener>
                )}
              </div>
            </Grid>
            <Grid item xs={12} className={classes.padding2x}>
              <Typography variant="h4" className={classes.courseTitle}>
                Select Scheduled Tests
              </Typography>
              <div className={classes.optionContainer}>
                <div
                  className={cx(
                    classes.plusCourse,
                    !selectedGoal.name ? classes.disabled : ""
                  )}
                  onClick={this.toggleTestDropdown}
                >
                  <input
                    type="text"
                    placeholder="Select Scheduled Tests"
                    value={this.testRenderer()}
                  />
                  {selectedTest.length > 3 && (
                    <span>+{selectedTest.length - 3}</span>
                  )}
                  <Grid className={classes.arrowIcon}>
                    {/* <KeyboardArrowDownIcon /> */}
                    <img src="/assets/svg/dropdown-arrow.svg" />
                  </Grid>
                </div>

                {showTestDropdown && (
                  <ClickAwayListener onClickAway={this.toggleTestDropdown}>
                    <div className={classes.optionlistContainer}>
                      <div className={classes.optionList}>
                        <div className={classes.searchContainer}>
                          <input
                            type="text"
                            placeholder="Search Test Name"
                            onChange={(event) => {
                              this.getTestSuggestions(event.target.value);
                            }}
                          />
                          <img src="/assets/svg/userManagement/search-icon.svg" />
                        </div>
                        {filteredTestList.length === 0 && (
                        <span>No Tests found</span>
                        )}
                        {filteredTestList.length > 0 && (
                          <span>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    filteredTestList.length ==
                                    selectedTest.length
                                  }
                                  onChange={this.handleTestChange}
                                  name="Select All"
                                  color="primary"
                                />
                              }
                              label="Select All"
                              value="SelectAll"
                              key="select_all_test"
                            />
                          </span>
                        )}
                        {(filteredTestList || []).map(
                          ({ _id, displayName, scheduleID,testType,paperDetail }) => (
                            <span>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedTest.includes(_id)}
                                    onChange={this.handleTestChange}
                                    name="checkedB"
                                    color="primary"
                                  />
                                }
                                label={`${displayName} | ${_.capitalize(testType?testType:paperDetail.type)} | ${paperDetail.contentId && mappingType==='mapped' ? paperDetail.contentId: 'Schedule ID: '+scheduleID}`}
                                key={_id}
                                value={_id}
                              />
                            </span>
                          )
                        )}
                      </div>
                    </div>
                  </ClickAwayListener>
                )}
              </div>
            </Grid>
            <Grid container className={classes.padding2x}>
              <Grid item xs={12} >
                <Typography variant="h4" className={classes.courseTitle}>
                  Enter Test Id
                  {formErrors.testId && (
                <span
                  className={classes.errorText}
                  color="error"
                  style={{float:'right'}}
                >
                  <Error /> {formErrors.testId}
                </span>
              )}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.parentSearchContainer}>
                  <input
                    type="text"
                    placeholder="Enter Test ID"
                    name="testId"
                    onChange={(event) => {
                      this.handleChange(event);
                    }}
                    disabled={selectedTest.length === 0}
                    value={inputTestId}
                  />
                  {/* <img src="/assets/svg/userManagement/search-icon.svg" /> */}
                </div>
              </Grid>
            </Grid>

            <Grid container className={classes.padding2x}>
            <Grid item xs={12} >
                <Grid className={classes.customSelect}>
                  <Typography variant="h4" className={classes.courseTitle}>
                    Select Primary Scheduled Test
                  </Typography>
                  <MyPATSelect
                    value={(primaryTest && primaryTest._id) || ""}
                    name="primaryTest"
                    onChange={(e: any) => this.handleChange(e)}
                    disabled={disabledPrimaryDropDown}
                  >
                    {this.renderPrimaryTestOptions()}
                  </MyPATSelect>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </MyPATDialog>
        {/* <Grid className={classes.noBorder}> */}
        <MyPATDialog
          dialogOpen={openConfirmationPopup}
          dialogHasActions={true}
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={() => this.closeConfirmationDialog()}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: false,
          }}
          customDialogActions={
            <>
              <Grid
                container
                justify="center"
                style={{ paddingBottom: "30px" }}
              >
                <Grid item>
                  <Button
                    color="primary"
                      onClick={() => this.closeConfirmationDialog()}
                  >
                    No
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.bulkMapProcess()}
                  >
                    Yes
                  </Button>
                </Grid>
              </Grid>
              <br />
            </>
          }
        >
          <Grid className={classes.buttonCloseCont}>
            <MyPATIconButton
              className={classes.buttonClose}
              buttonVariant="flat"
              onClick={() => this.closeConfirmationDialog()}
            >
              <CloseIcon classes={{ root: classes.iconRoot }} />
            </MyPATIconButton>
          </Grid>
          <Grid container justify="center" style={{ textAlign: "center" }}>
            <Grid item>
              <img width="68" src="/assets/svg/map-scheduled-icon.svg" />
              <h3>Map Scheduled Test</h3>
              <Typography>
                Are you sure, you want to map {selectedTest.length} tests in these <span style={{color: '#1d7dea', cursor: "pointer"}} onClick={() => this.downloadCourseSheet()}>{this.state.testCourseCount} courses</span>?
              </Typography>
            </Grid>
          </Grid>
        </MyPATDialog>
        {/* </Grid> */}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  courseList: state.clientManagement.usersManagement.courseList,
  goals: state.courseMangementData.courseManagementReducer.activeGoals,
  scheduledTests:
    state.courseMangementData.courseManagementReducer.scheduledTests,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      // fetchExistingScheduledTests:courseManagementActions.fetchExistingScheduledTests,
      fetchScheduleTests: courseManagementActions.fetchScheduleTests,
      getActiveGoals: getActiveGoals,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(MapSCheduledTest));
